// src/components/CustomerProtectedRoute.jsx - REVISED version preserving all existing functionality
import React from 'react';
import { Navigate, Outlet, useParams, useLocation } from 'react-router-dom';
import { useCustomerAuth } from '../contexts/CustomerAuthContext';

function CustomerProtectedRoute() {
  const { currentUser, currentCustomer, loading } = useCustomerAuth();
  const { salonId } = useParams();
  const location = useLocation();

  console.log('CustomerProtectedRoute - Debug:', {
    currentUser: !!currentUser,
    currentCustomer: !!currentCustomer,
    loading,
    salonId,
    pathname: location.pathname
  });

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (!currentUser || !currentCustomer) {
    // Determine the correct login URL based on current path structure
    const loginUrl = location.pathname.includes('/BespokeBeauty/') 
      ? `/BespokeBeauty/${salonId}/customer/login`
      : `/salon/${salonId}/login`;
    
    console.log('CustomerProtectedRoute - Redirecting to:', loginUrl);
    return <Navigate to={loginUrl} replace />;
  }

  return <Outlet />;
}

export default CustomerProtectedRoute;